import {useEmployeeNotificationState} from "app/employee/state/notification/mutations";
import {useShallow} from "zustand/react/shallow";

export const useNotificationsAlertLastDismiss = () => {
  const [lastDismissedAtSeconds, setLastDismissedAtSeconds] = useEmployeeNotificationState(
    useShallow((state) => [state.lastDismissedAtSeconds, state.setLastDismissedAtSeconds])
  );
  return {lastDismissedAtSeconds, setLastDismissedAtSeconds};
};
